import * as tslib_1 from "tslib";
import { FieldType } from '@ngx-formly/core';
var FormlyFieldOptionListComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FormlyFieldOptionListComponent, _super);
    function FormlyFieldOptionListComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FormlyFieldOptionListComponent;
}(FieldType));
export { FormlyFieldOptionListComponent };
